// Картата „Продукти" на листа „Изписване": заглавие с броя редове, чиповете
// „общо количество по мерна единица" (и порциите от рецептите) и решетката/
// картите с един keydown handler за стрелките (`onGridKey`). Картата расте до
// края на екрана и скролва вътре — заглавният ред на решетката остава лепнат.
import { useTranslation } from "react-i18next";
import { WriteoffWorksheetTable, type WriteoffTableProps } from "./WriteoffWorksheetTable";
import { formatPortionsInput, formatQtyInput } from "./writeoffWorksheetShared";

type Props = {
  unitTotals: {
    units: [string, { qty: number; dec: number }][];
    portions: number;
  };
  onGridKey: (event: React.KeyboardEvent) => void;
  table: WriteoffTableProps;
};

const TotalChip = ({ value, unit }: { value: string; unit: string }) => (
  <span className="rounded-full bg-fill-2 px-2.5 py-[3px] text-[12.5px] text-ink-2">
    <span className="font-sheet font-semibold">{value}</span> {unit}
  </span>
);

export const WriteoffProductsCard = ({ unitTotals, onGridKey, table }: Props) => {
  const { t } = useTranslation();
  const count = table.lines.length;
  return (
    <div className="flex min-h-[360px] flex-1 flex-col overflow-hidden rounded-xl border border-shade-2 bg-panel">
      <div className="flex flex-wrap items-center gap-2.5 px-[18px] py-[13px]">
        <span className="text-[15px] font-semibold text-ink">{t("inventoryPage.productsTitle")}</span>
        <span className="text-[12.5px] text-muted">{t("inventoryPage.woLinesCount", { count })}</span>
        <div className="flex-1" />
        {unitTotals.units.map(([unit, { qty, dec }]) => (
          <TotalChip key={unit} value={formatQtyInput(qty, dec)} unit={unit} />
        ))}
        {unitTotals.portions > 0 && (
          <TotalChip value={formatPortionsInput(unitTotals.portions)} unit={t("inventoryPage.unitPortions")} />
        )}
      </div>
      <div
        className={`min-h-0 flex-1 overflow-auto border-t border-shade-2 text-[13px] ${
          count ? "bg-surface" : "bg-panel"
        }`}
        onKeyDown={onGridKey}
      >
        <WriteoffWorksheetTable {...table} />
      </div>
    </div>
  );
};

export default WriteoffProductsCard;
